import Tribe from "../enum/Tribe";

export function isPlayableTribe(tribe: Tribe): boolean {
    return tribe !== Tribe.Nature && tribe !== Tribe.Natars;
}
